import React from 'react';
import SbEditable from 'storyblok-react';
import Img from 'gatsby-image';
import { getFluidGatsbyImage } from 'gatsby-storyblok-image';
import styled from 'styled-components';
import tw from 'twin.macro';
import { useInView } from 'react-intersection-observer';
import Lottie from 'react-lottie-player';

// Fix for gatsby image's handling of the .object-cover className
const GatsbyObjectFitWrapper = styled.div`
  &.object-cover {
    ${tw`w-full h-full`}

    .gatsby-image-wrapper {
      ${tw`w-full h-full`}
    }

    img {
      ${tw`object-cover w-full h-full`}
    }
  }
  &.object-contain {
    ${tw`w-auto h-full max-w-full`}

    .gatsby-image-wrapper {
      ${tw`w-full h-full`}
    }

    img {
      ${tw`object-contain! h-full w-full`}
    }
  }
  &.object-left {
    img {
      ${tw`object-left!`}
    }
  }
  &.object-center-left {
    img {
      ${tw`object-center md:object-left!`}
    }
  }
`;

const FluidImage = ({ blok, className = '', imageClassName = '', align = 'mx-auto', imgStyle = '', ...other }) => {
  const [ref, inView] = useInView({
    // triggerOnce: true,
    threshold: 0,
  });

  if (!blok?.filename && !blok?.image?.filename) return null;

  const fileName = blok.filename || blok.image?.filename;
  const altText = blok.alt || blok.image?.alt;

  if (fileName.length) {
    const fluidProps = getFluidGatsbyImage(fileName, {
      maxWidth: 800,
    });

    return (
      <SbEditable content={blok}>
        <GatsbyObjectFitWrapper className={`${className} ${blok.className || ''} ${align} w-full`} ref={ref}>
          {fileName.includes('.json') ? (
            <div>
              <Lottie play={inView} height={'100%'} width={'100%'} path={fileName} loop={false} rendererSettings={{ filterSize: {width: '200%',height: '200%',x: '-50%',y: '-50%'}  }} />
            </div>
          ) : fileName.includes('.svg') ? (
            <img className={imageClassName} src={fileName} alt={altText} draggable="false" {...other} />
          ) : (
            <Img className={imageClassName} fluid={fluidProps} alt={altText} draggable={false} fadeIn={true} {...other} imgStyle={imgStyle} />
          )}
        </GatsbyObjectFitWrapper>
      </SbEditable>
    );
  }
};

export default FluidImage;
